import React, { useEffect, useState } from 'react'
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  Image,
  Row,
  ToggleButton
} from 'react-bootstrap'
import NavTitle from '../../components/nav-title'
import NavRoleOrg from '../../components/nav-role-org'
import ImgUser from '../../images/user.png'
import { useSelector } from 'react-redux'
import Error_false from '../../components/error/error-false'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import CardCustom from '../../components/custom/card-custom'
import {
  createSearchParams,
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams
} from 'react-router-dom'
import { EMP_PVD_HISTORY } from '../../router/routes'
import { useDebounce } from '@react-hook/debounce'
import iconHistory from '../../images/history2.png'
import TextNavTitle from '../../components/TextNavTitle'
import { URL_PROFILE } from '../../Constants'
import { getTransferNewAPI } from '../../services/transfer'

export default function TransferPage() {
  let [searchParams, setSearchParams] = useSearchParams()
  const roleId = useSelector((state) => state.roleReducer.role)
  const [search, setSearch] = useDebounce('', 1000)
  const [selectedRow, setSelectedRow] = useState(null)
  const [page, setPage] = useState(1)
  const [dataEmps, setDataEmps] = useState([])
  const [totalRows, setTotalRows] = useState(0)
  const [totalLimits, setTotalLimits] = useState(0)
  const [isLoading, setIsLoading] = useState(false)

  const navigate = useNavigate()
  const locaiton = useLocation()
  const pathname = locaiton.pathname
  const menuSubList = useSelector((state) => state.allMenuReducer.allMenu)
  const [newMenu, setNewMenu] = useState([])
  const [bodyFilter, setBodyFilter] = useState()
  useEffect(() => {
    if (menuSubList && menuSubList.allMenu) {
      const menuMain = menuSubList.allMenu.find((item) => item.id === 11) //id emp

      if (menuMain) {
        const subMenu = menuMain.submenu.find((item) => item.menuId === 11) //id "Transfer"

        if (subMenu?.menuSubList.length > 0) {
          setNewMenu(subMenu?.menuSubList)
        }
      }
    }
  }, [menuSubList])

  useEffect(() => {
    if (roleId) {
      const body = {
        page,
        orgId: roleId,
        searchs: search,
        statusId: 1
      }
      getEmps(body)
      setSearchParams({})
    }
  }, [page, roleId, search])

  useEffect(() => {
    if (roleId) {
      const body = {
        page: 1,
        orgId: roleId,
        searchs: search,
        statusId: 1
      }
      getEmps(body)
    }
  }, [roleId])

  const getEmps = async (body) => {
    setBodyFilter(body)
    setIsLoading(true)
    const data = await getTransferNewAPI(body)
    if (!data) return
    if (data.status) {
      setDataEmps(data.result)
      setTotalRows(data.totalRows)
      setTotalLimits(data.totalLimits)
    } else {
      Error_false(data)
    }
    setIsLoading(false)
  }

  const onHistory = () => {
    navigate(
      {
        pathname: `${EMP_PVD_HISTORY}`
      },
      { replace: true }
    )
  }

  const onSearch = (e) => {
    setPage(1)
    setSearch(e)
  }

  const handClick = (d) => {
    navigate(
      {
        pathname: `${pathname}`,
        search: `?${createSearchParams({
          uuid: d.uuid
          // code: d.code,
          // img: d.folder_img
        })}`
      },
      { replace: true }
    )
    setSelectedRow(d)
  }

  const menus = newMenu.map((m, i) => {
    return {
      id: m.id,
      label: m.label,
      link: m.link
    }
  })

  const fnGetData = () => getEmps(bodyFilter)
  const heightCalc = 'calc(100vh - 200px)'
  return (
    <Row>
      <NavTitle>
        <TextNavTitle>Transfer</TextNavTitle>
      </NavTitle>
      <Col xl={12}>
        <NavRoleOrg />
        {/* {newMenu.length > 0 ? ( */}
        <CardCustom minHeight="" border="0" className="">
          <div className="p-2">
            <div className="row">
              <div className="col-6">
                <ButtonGroup
                  className="rounded-3 my-auto"
                  style={{
                    border: '0px solid #EFEFEF',
                    padding: '1px',
                    height: '40px',
                    maxWidth: 500,
                    position: 'relative'
                  }}
                >
                  {menus.map((d, idx) => (
                    <ToggleButton
                      key={idx}
                      id={`orgrole-${d}`}
                      type="radio"
                      variant="outline-primary"
                      name="orgrole"
                      className={`border-0 my-auto pointer-event fw-bold ${
                        pathname !== d.link && 'opacity-25'
                      }`}
                      onClick={() => {
                        navigate(d.link)
                      }}
                    >
                      {d.label}
                    </ToggleButton>
                  ))}
                </ButtonGroup>
              </div>
              {roleId ? (
                <div className="col-6 d-flex justify-content-end align-items-center">
                  <Button
                    variant="outline-secondary"
                    className=" d-flex justify-content-end me-2 "
                    type="button"
                    size="sm"
                    onClick={onHistory}
                  >
                    <div className="">
                      <Image
                        src={iconHistory}
                        className="me-1 mb-1"
                        style={{
                          width: 15
                        }}
                      />
                      <iconHistory />
                      History
                    </div>
                  </Button>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
          <Card.Body className="pt-0 border-top ">
            <Row>
              <Col
                xl={4}
                style={{
                  height: heightCalc
                }}
                className="border-end overflow-auto"
              >
                {roleId ? (
                  <>
                    <Row
                      className="border-bottom pb-3  position-sticky bg-white"
                      style={{ top: 0 }}
                    >
                      <Col className="pt-3">
                        <Form.Control
                          className=""
                          placeholder="Name/ Code"
                          onChange={(e) => onSearch(e.target.value)}
                        />
                      </Col>
                    </Row>

                    {dataEmps.length > 0 &&
                      dataEmps.map((d, i) => (
                        <Row
                          className="pt-3 pb-3 border-bottom pointer-event"
                          style={{
                            backgroundColor: `${
                              selectedRow === d ? `#EEF5FD` : ``
                            }`
                          }}
                          key={i}
                          onClick={() => {
                            handClick(d)
                          }}
                        >
                          <Col className="d-flex" xl={6}>
                            <Image
                              fluid
                              className="rounded-circle "
                              style={{
                                maxWidth: 40,
                                maxHeight: 40,
                                objectFit: 'cover'
                              }}
                              src={`${URL_PROFILE}/${d?.folder_img}/${d?.code}_cr.jpg`}
                              // src={`${d?.img_url}`}
                              onError={(event) => {
                                event.target.src = ImgUser
                                event.onerror = null
                              }}
                            />
                            <div className="ms-3">
                              <p
                                className="mb-0 box-text-1 small"
                                style={{
                                  fontSize: 14
                                }}
                              >
                                {' '}
                                {d.title_en} {d.name_en} {d.surname_en}
                              </p>
                              <p
                                className="mb-0 fw-light small"
                                style={{
                                  fontSize: 12
                                }}
                              >
                                {d.code}
                              </p>
                            </div>
                          </Col>
                          <Col xl={6}>
                            <p
                              className="mb-0 fw-light box-text-1 small"
                              style={{
                                fontSize: 14
                              }}
                            >
                              {d.email}
                            </p>
                            <p
                              className="mb-0 fw-light small"
                              style={{
                                fontSize: 12
                              }}
                            >
                              {d.phone}
                            </p>
                          </Col>
                        </Row>
                      ))}

                    <div
                      className="pt-3 position-sticky bg-white "
                      style={{ margin: -12, bottom: 0 }}
                    >
                      <PaginationControl
                        page={page}
                        total={totalRows}
                        limit={totalLimits}
                        changePage={(page) => {
                          setPage(page)
                        }}
                        ellipsis={1}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="d-flex justify-content-center mt-5 text-secondary small">
                      - ไม่พบ ORG ของท่านในระบบ โปรดติดต่อแผนก IT -
                    </div>
                  </>
                )}
              </Col>
              <Col
                xl={8}
                className="overflow-auto"
                style={{
                  height: heightCalc
                }}
              >
                {/* {pathname === '/employee/transfer' ? (
                  <DetailEmployee getFnData={() => getEmps(bodyFilter)} />
                ) : pathname === '/employee/transfer/transfer-org' ? (
                  <DetailEmployeeOrg getFnData={() => getEmps(bodyFilter)} />
                ) : null} */}

                <Outlet context={[fnGetData]} />
              </Col>
            </Row>
          </Card.Body>
        </CardCustom>
      </Col>
    </Row>
  )
}
